import React, { useEffect } from "react";
import { Box } from "@mui/material";
import HeroSection from "../../components/heroSection/hero";
import BgImage from "../../images/background.png";
import Contact from "../../components/contactus/contact";

function ContactUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <HeroSection heroBgImage={BgImage} text={"Contact Us"} />
      <Contact />
    </Box>
  );
}

export default ContactUsPage;
